import wrapInApiUrl from "./wrapInApiUrl"
import axios from "axios"

const api = (endpoint, data = {}) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.GATSBY_BEARER_TOKEN}`,
  }

  // const options = {
  //   method: "POST",
  //   mode: "cors",
  //   cache: "no-cache",
  //   headers,
  // }
  // if (!isEmpty(data)) {
  //   // if (method !== "GET") {
  //   //   options.body = JSON.stringify(data)
  //   // } else {
  //   //   endpoint += `?${stringify(data)}`
  //   // }
  //   options.body = JSON.stringify(data)
  // }
  return axios({
    method: "post",
    url: wrapInApiUrl(endpoint),
    headers,
    data,
  })
}

export default api
